module.exports = __webpack_public_path__ + "static/way-you-persuade-664f7fb0d0ea22dcd00a173582db0c1a.webp";